// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @28.05.2021 13:27:21

import { CPersonBase_abstract } from './../abstract/SagaSchema/CPersonBase_abstract';

export class CPersonBase extends CPersonBase_abstract {
  get icon(): string {
    return 'person';
  }
}
